import {IReduxMarkableAsReadFeatureState} from '../../../@interfaces';

const state: IReduxMarkableAsReadFeatureState = {
    readCommentsIds: {},
};

export default state;
